module.exports = __webpack_public_path__ + "static/scale-model-of-chicago-illinois-ba72f9abe7d8be308a97ca174c9706de.png";